import { render, staticRenderFns } from "./QuestStructuresConsents.vue?vue&type=template&id=f3842a86&"
import script from "./QuestStructuresConsents.vue?vue&type=script&lang=js&"
export * from "./QuestStructuresConsents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./QuestStructuresConsents.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports